import { RequestStatus } from 'features/request/requestSlice';
import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { uerSetWorkOrderWorkRatioGql } from '../../workOrderQueries';

interface IUseUerSetWorkOrderWorkRatio {
    workOrderPriceId: number;
    onSuccess: () => void;
}

export const useUerSetWorkOrderWorkRatio = (props: IUseUerSetWorkOrderWorkRatio) => {
    const dispatch = useDispatch();

    const { workOrderPriceId, onSuccess } = props;

    const requestId = useMemo(() => `uerSetWorkOrderWorkRatio_${workOrderPriceId}`, [workOrderPriceId]);

    const [uerSetWorkOrderWorkRatioReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(() => {
        uerSetWorkOrderWorkRatioReset(undefined);

        onSuccess();
    }, [onSuccess, uerSetWorkOrderWorkRatioReset]);

    const [
        ,
        uerSetWorkOrderWorkRatioStatus,
        ,
        uerSetWorkOrderWorkRatioRequest,
        ,
        uerSetWorkOrderWorkRatioAbortRequest,
    ] = useRequest({
        requestId,
        withEffect: false,
        query: uerSetWorkOrderWorkRatioGql,
        dependenciesUpdater: onSuccessLocal,
    });

    const uerSetWorkOrderWorkRatioMakeRequest = useCallback(
        (ratio: number) => {
            const params = { workOrderPriceId, ratio };

            if (uerSetWorkOrderWorkRatioStatus === RequestStatus.FETCHING) {
                dispatch(uerSetWorkOrderWorkRatioAbortRequest(undefined));
            }

            dispatch(uerSetWorkOrderWorkRatioRequest(params));
        },
        [
            dispatch,
            uerSetWorkOrderWorkRatioAbortRequest,
            uerSetWorkOrderWorkRatioRequest,
            uerSetWorkOrderWorkRatioStatus,
            workOrderPriceId,
        ],
    );

    return { uerSetWorkOrderWorkRatioMakeRequest, uerSetWorkOrderWorkRatioStatus };
};
